module.exports = __webpack_public_path__ + "img/panelDashboards.e8c910e1.svg";